import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue"
import _imports_0 from './assets/备案图标.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "left-section" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = { class: "nav-menu desktop-menu" }
const _hoisted_6 = { class: "right-section" }
const _hoisted_7 = {
  key: 0,
  class: "auth-buttons"
}
const _hoisted_8 = { class: "user-section" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "tooltip-header" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "tooltip-user-info" }
const _hoisted_13 = { class: "tooltip-name-wrapper" }
const _hoisted_14 = { class: "tooltip-name" }
const _hoisted_15 = { class: "tooltip-details" }
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "detail-item" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "tooltip-actions" }
const _hoisted_21 = { class: "menu-icon-container" }
const _hoisted_22 = {
  key: 0,
  class: "mobile-auth-buttons"
}
const _hoisted_23 = { class: "footer-content" }
const _hoisted_24 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_VipBadge = _resolveComponent("VipBadge")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_NotificationIcon = _resolveComponent("NotificationIcon")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_VipRedeemDialog = _resolveComponent("VipRedeemDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_header, {
      class: "header",
      height: "85px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createElementVNode("h1", null, "AiVitaHelper", -1)
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "nav-item"
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("首页")
                ])),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/resume",
                class: "nav-item"
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("简历优化")
                ])),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/resources/simple",
                class: "nav-item"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("资源管理")
                ])),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/xiaoguo-square",
                class: "nav-item"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("小果广场")
                ])),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/about",
                class: "nav-item"
              }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createTextVNode("关于")
                ])),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    class: "login-btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('login')))
                  }, {
                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createTextVNode("登录")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    class: "register-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('register')))
                  }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("注册")
                    ])),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "user-info",
                      onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showTooltip = true)),
                      onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTooltip = false)),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo('user-profile')))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.avatarUrl,
                        alt: _ctx.currentUser?.username || '用户头像',
                        class: "user-avatar"
                      }, null, 8, _hoisted_9),
                      (_ctx.currentUser?.vip)
                        ? (_openBlock(), _createBlock(_component_VipBadge, {
                            key: 0,
                            level: _ctx.currentUser.vip,
                            "expires-at": _ctx.currentUser.vipExpiresAt,
                            type: "mini",
                            class: "avatar-vip-badge"
                          }, null, 8, ["level", "expires-at"]))
                        : _createCommentVNode("", true)
                    ], 32),
                    _withDirectives(_createElementVNode("div", {
                      class: "user-tooltip",
                      onMouseenter: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showTooltip = true)),
                      onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showTooltip = false))
                    }, [
                      _createElementVNode("div", {
                        class: "tooltip-content",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateTo('user-profile')))
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("img", {
                            src: _ctx.avatarUrl,
                            alt: _ctx.currentUser?.username || '用户头像',
                            class: "tooltip-avatar"
                          }, null, 8, _hoisted_11),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentUser?.username || '未知用户'), 1),
                              (_ctx.currentUser?.vip)
                                ? (_openBlock(), _createBlock(_component_VipBadge, {
                                    key: 0,
                                    level: _ctx.currentUser.vip,
                                    "expires-at": _ctx.currentUser.vipExpiresAt,
                                    type: "mini"
                                  }, null, 8, ["level", "expires-at"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "账号：", -1)),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentUser?.account), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "邮箱：", -1)),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.currentUser?.email), 1)
                          ])
                        ])
                      ]),
                      _createVNode(_component_el_divider),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                          class: "action-btn",
                          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.navigateTo('user-profile', '#settings')), ["stop"]))
                        }, "设置"),
                        _createElementVNode("button", {
                          class: "action-btn",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showVipRedeemDialog && _ctx.showVipRedeemDialog(...args)), ["stop"]))
                        }, _toDisplayString(_ctx.currentUser?.vip ? 'VIP兑换码' : 'VIP兑换码'), 1),
                        _createElementVNode("button", {
                          class: "action-btn logout-btn",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)), ["stop"]))
                        }, "退出登录")
                      ])
                    ], 544), [
                      [_vShow, _ctx.showTooltip]
                    ])
                  ]),
                  _createVNode(_component_NotificationIcon)
                ], 64)),
            _createElementVNode("div", {
              class: "mobile-menu-btn",
              onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMobileMenu && _ctx.toggleMobileMenu(...args)), ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_21, [
                (!_ctx.mobileMenuVisible)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Menu)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Close)
                      ]),
                      _: 1
                    }))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["mobile-menu", { 'mobile-menu-visible': _ctx.mobileMenuVisible }])
        }, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "mobile-nav-item",
            onClick: _ctx.closeMobileMenu
          }, {
            default: _withCtx(() => _cache[25] || (_cache[25] = [
              _createTextVNode("首页")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/resume",
            class: "mobile-nav-item",
            onClick: _ctx.closeMobileMenu
          }, {
            default: _withCtx(() => _cache[26] || (_cache[26] = [
              _createTextVNode("简历优化")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/resources/simple",
            class: "mobile-nav-item",
            onClick: _ctx.closeMobileMenu
          }, {
            default: _withCtx(() => _cache[27] || (_cache[27] = [
              _createTextVNode("资源管理")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/xiaoguo-square",
            class: "mobile-nav-item",
            onClick: _ctx.closeMobileMenu
          }, {
            default: _withCtx(() => _cache[28] || (_cache[28] = [
              _createTextVNode("小果广场")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_router_link, {
            to: "/about",
            class: "mobile-nav-item",
            onClick: _ctx.closeMobileMenu
          }, {
            default: _withCtx(() => _cache[29] || (_cache[29] = [
              _createTextVNode("关于")
            ])),
            _: 1
          }, 8, ["onClick"]),
          (!_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_el_button, {
                  size: "small",
                  class: "login-btn",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.navigateTo('login')))
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode("登录")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "primary",
                  class: "register-btn",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.navigateTo('register')))
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("注册")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }),
    _createVNode(_component_el_main, { class: "main-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view, null, {
          default: _withCtx(({ Component }) => [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_footer, { class: "footer" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createTextVNode(" © " + _toDisplayString(_ctx.currentYear) + " AI简历助手. 保留所有权利. ", 1),
            _cache[32] || (_cache[32] = _createElementVNode("a", {
              href: "https://beian.miit.gov.cn",
              target: "_blank",
              class: "beian-link"
            }, "京ICP备2025105454号-2 ", -1)),
            _cache[33] || (_cache[33] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Icon",
              width: "10"
            }, null, -1)),
            _cache[34] || (_cache[34] = _createElementVNode("a", {
              href: "https://beian.mps.gov.cn/#/query/webSearch?code=11010802045582",
              rel: "noreferrer",
              target: "_blank",
              class: "beian-link"
            }, "京公网安备11010802045582号", -1))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_VipRedeemDialog, {
      visible: _ctx.vipRedeemDialogVisible,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.vipRedeemDialogVisible) = $event)),
      onRedeemed: _ctx.handleVipRedeemed
    }, null, 8, ["visible", "onRedeemed"])
  ]))
}